function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAWolontariat = function SvgAWolontariat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Warstwa 1",
    viewBox: "0 0 155.5 155.5"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M106.37 101.28c0-2.22-.13-4.4-.39-6.51-1.91-16.23-10.96-29.58-23.9-37.53-8.31-5.11-18.22-7.99-28.9-7.99v21.8c16.27 0 28.9 12.44 28.9 30.23s-12.63 30.23-28.9 30.23v21.82c10.68 0 20.59-2.88 28.9-7.95.13-.08.25-.17.38-.24v6.49h23.91v-49.55h-.02c0-.27.02-.53.02-.79Z",
    style: {
      fill: "#091f2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.32 101.28c0 18.56 12.63 30.23 28.89 30.23v21.82c-30.8 0-53.18-21.82-53.18-52.05s22.38-52.03 53.18-52.03v21.8c-16.26 0-28.89 12.44-28.89 30.23",
    style: {
      fill: "#5ea570"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.03 0h155.5v155.5H.03z",
    style: {
      fill: "none"
    }
  }));
};
export default SvgAWolontariat;